import type { ActionsOf } from 'store/types';

import type {
  LocationChangePayload,
  PageRequestPayload,
  PageSuccessPayload,
  PageErrorPayload,
  SetIsLoadedPayload,
  SetIsFetchingPayload,
  UserSessionExpiredPayload,
} from './types';

export const INITIALIZE = 'app/INITIALIZE_REQUEST';
export const INITIALIZE_SUCCESS = 'app/INITIALIZE_SUCCESS';
export const PROCESS_CLASSES = 'app/PROCESS_CLASSES';
export const FINISHES = 'app/FINISHES';
export const ERROR = 'app/ERROR';
export const BLANK = 'app/BLANK';
export const SET_IS_LOADED = 'app/SET_IS_LOADED';
export const SET_IS_FETCHING = 'app/SET_IS_FETCHING';
export const PAGE_REQUEST = 'app/PAGE_REQUEST';
export const PAGE_SUCCESS = 'app/PAGE_SUCCESS';
export const PAGE_ERROR = 'app/PAGE_ERROR';
export const PAGE_PENDING_START = 'app/PAGE_PENDING_START';
export const PAGE_PENDING_FINISH = 'app/PAGE_PENDING_FINISH';
export const LOCATION_CHANGE = 'app/LOCATION_CHANGE';
export const USER_SESSION_EXPIRED = 'app/USER_SESSION_EXPIRED';

export const types = {
  INITIALIZE,
  INITIALIZE_SUCCESS,
  PROCESS_CLASSES,
  FINISHES,
  ERROR,
  BLANK,
  SET_IS_LOADED,
  SET_IS_FETCHING,
  PAGE_REQUEST,
  PAGE_SUCCESS,
  PAGE_ERROR,
  PAGE_PENDING_START,
  PAGE_PENDING_FINISH,
  LOCATION_CHANGE,
  USER_SESSION_EXPIRED,
} as const;

export const initializeSuccess = () => ({ type: types.INITIALIZE_SUCCESS });

export const changeLocation = ({ location }: LocationChangePayload) => ({
  type: types.LOCATION_CHANGE,
  payload: { location },
});

export const page = {
  request: ({ location }: PageRequestPayload) => ({
    type: types.PAGE_REQUEST,
    payload: { location },
  }),
  success: ({ model }: PageSuccessPayload) => ({
    type: types.PAGE_SUCCESS,
    payload: { model },
  }),
  error: ({ error }: PageErrorPayload) => ({
    type: types.PAGE_ERROR,
    payload: { error },
  }),
};

export const setIsLoaded = ({ isLoaded }: SetIsLoadedPayload) => ({
  //isLoaded
  type: types.SET_IS_LOADED,
  payload: { isLoaded },
});

export const setIsFetching = ({ isFetching }: SetIsFetchingPayload) => ({
  type: types.SET_IS_FETCHING,
  payload: { isFetching },
});

export const setDidSessionExpire = ({
  didSessionExpire,
}: UserSessionExpiredPayload) => ({
  type: types.USER_SESSION_EXPIRED,
  payload: { didSessionExpire },
});

export const pagePending = {
  start: () => ({
    type: types.PAGE_PENDING_START,
  }),
  finish: () => ({
    type: types.PAGE_PENDING_FINISH,
  }),
};

export type AppAction = ActionsOf<{
  changeLocation: typeof changeLocation;
  initializeSuccess: typeof initializeSuccess;
  page: typeof page;
  pagePending: typeof pagePending;
  setDidSessionExpire: typeof setDidSessionExpire;
  setIsFetching: typeof setIsFetching;
  setIsLoaded: typeof setIsLoaded;
}>;
